import { dictionaries } from './locales/index.js';

export const supportedLocales = Object.freeze(Object.keys(dictionaries));
export const defaultLocale = 'en';

export function normalizeLocale(locale = defaultLocale) {
  if (typeof locale !== 'string') throw new TypeError('[PositiveNav] locale must be a string.');
  const language = locale.trim().toLowerCase().split(/[-_]/)[0];
  return supportedLocales.includes(language) ? language: defaultLocale;
}

function readValue(messages, key) {
  let value = messages;
  for (const segment of key.split('.')) {
    if (!value || typeof value !== 'object' || !Object.prototype.hasOwnProperty.call(value, segment)) return undefined;
    value = value[segment];
  }
  return value;
}

/** Internal translator with bundled dictionaries, per-key fallback and text-only interpolation. */
export function createTranslator(locale, messages = dictionaries) {
  const language = normalizeLocale(locale);
  return (key, values = {}) => {
    if (typeof key !== 'string' || !key) throw new TypeError('[PositiveNav] A translation key is required.');
    const localized = readValue(messages, `${language}.${key}`);
    const fallback = readValue(messages, `${defaultLocale}.${key}`);
    const usable = (message) => typeof message === 'string' && message.trim().length > 0;
    const message = usable(localized) ? localized: usable(fallback) ? fallback: key;
    return message.replace(/\{(\w+)\}/g, (match, name) => values != null && Object.prototype.hasOwnProperty.call(values, name) && values[name] != null
      ? String(values[name]): match);
  };
}

/** Brands and destinations stay in the catalog; only content is translated. */
export function localizeProduct(product, t) {
  if (product.currentOnly) {
    const category = t(product.categoryKey);
    return Object.freeze({ category, tagline: category, description: '', features: Object.freeze([]) });
  }
  const features = readValue(dictionaries.en, `${product.translationKey}.features`) ?? [];
  return Object.freeze({
    category: t(product.categoryKey),
    tagline: t(`${product.translationKey}.tagline`),
    description: t(`${product.translationKey}.description`),
    features: Object.freeze(features.map((_, index) => t(`${product.translationKey}.features.${index}`))),
  });
}
